import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroCodigo'
})
export class FiltroCodigoPipe implements PipeTransform {

  transform(numero: any, idAdmin: any): any[] {
    let numModificado = numero;
    if(idAdmin == 46 || idAdmin == 8) {
        const codigo = `${numero[0]}${numero[1]}${numero[2]}`;
        if(numero.length > 10 && codigo == '521') {
          numModificado = numero.slice(3);
        }
      }
    return numModificado;
  }

}
